import React from 'react'
import IsraelAdesanyaComp from '../../components/sponsorships/IsraelAdesanya'

const IsraelAdesanya = () => {
  return (
    <IsraelAdesanyaComp/>
  )
}

export default IsraelAdesanya